var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import WPSResource from "./module/WPS.resource.js";
import { loadResourcesUtils } from "@ane/core/lib/utils/LoadResourcesUtils";
import { getDefaultAsyncWrapperObj } from "@ane/core/lib/models";
import { createAction } from "typesafe-actions";
const defaultReducerState$9 = getDefaultAsyncWrapperObj();
const getWorkspaceMetaDataPrefix = "GetWorkspaceMetaData";
const workspaceMetaDataLoadEpicReducerArg = {
  actionPrefix: getWorkspaceMetaDataPrefix,
  reduxKeyNested: (inputPayload) => [ROOT_REDUCER_KEYS.METADATA, METADATA_ACTION_KEYS.GET],
  loadResource: (request) => WPSResource.getWorkspaceMetaData(request.workspaceId),
  onCompleteSuccess: (resourcesResult) => resourcesResult
};
const workspaceMetaDataLoadEpicReducer = loadResourcesUtils(workspaceMetaDataLoadEpicReducerArg);
const defaultReducerState$8 = getDefaultAsyncWrapperObj();
const workspaceProxyStatusUpdatePrefix = "workspaceProxyStatusUpdate";
const workspaceProxyStatusUpdateEpicReducerArg = {
  actionPrefix: workspaceProxyStatusUpdatePrefix,
  reduxKeyNested: (inputPayload) => [
    ROOT_REDUCER_KEYS.PROXY_STATUS,
    PROXY_STATUS_ACTION_KEYS.PUT
  ],
  loadResource: (request) => WPSResource.updateWorkspaceProxyStatus(request),
  onCompleteSuccess: (resourcesResult) => resourcesResult
};
const workspaceProxyStatusUpdateEpicReducer = loadResourcesUtils(workspaceProxyStatusUpdateEpicReducerArg);
const defaultReducerState$7 = getDefaultAsyncWrapperObj();
const workspaceProxyStatusGetPrefix = "workspaceProxyStatusGet";
const workspaceProxyStatusGetEpicReducerArg = {
  actionPrefix: workspaceProxyStatusGetPrefix,
  reduxKeyNested: (inputPayload) => [
    ROOT_REDUCER_KEYS.PROXY_STATUS,
    PROXY_STATUS_ACTION_KEYS.GET
  ],
  loadResource: (request) => WPSResource.getWorkspaceProxyStatus(request.workspaceId),
  onCompleteSuccess: (resourcesResult) => resourcesResult
};
const workspaceProxyStatusGetEpicReducer = loadResourcesUtils(workspaceProxyStatusGetEpicReducerArg);
const defaultReducerState$6 = getDefaultAsyncWrapperObj();
const workspaceSecurityGroupsPutPrefix = "WorkspaceSecurityGroupsPut";
const workspaceSecurityGroupsPutEpicReducerArg = {
  actionPrefix: workspaceSecurityGroupsPutPrefix,
  reduxKeyNested: (inputPayload) => [
    ROOT_REDUCER_KEYS.WORKSPACE_SG,
    WORKSPACE_SG_ACTION_KEYS.PUT
  ],
  loadResource: (request) => {
    return WPSResource.putWorkspaceSecurityGroups(request.workspaceId, request.data);
  },
  onCompleteSuccess: (resourcesResult) => resourcesResult
};
const workspaceSecurityGroupsPutEpicReducer = loadResourcesUtils(workspaceSecurityGroupsPutEpicReducerArg);
const defaultReducerState$5 = getDefaultAsyncWrapperObj();
const workspaceServicePrincipalsPutPrefix = "WorkspaceServicePrincipalsPut";
const workspaceServicePrincipalsPutEpicReducerArg = {
  actionPrefix: workspaceServicePrincipalsPutPrefix,
  reduxKeyNested: (inputPayload) => [
    ROOT_REDUCER_KEYS.WORKSPACE_SP,
    WORKSPACE_SP_ACTION_KEYS.PUT
  ],
  loadResource: (request) => {
    return WPSResource.putWorkspaceServicePrincipals(
      request.workspaceId,
      request.servicePrincipalId,
      request.data,
      request.identityType
    );
  },
  onCompleteSuccess: (resourcesResult) => resourcesResult
};
const workspaceServicePrincipalsPutEpicReducer = loadResourcesUtils(workspaceServicePrincipalsPutEpicReducerArg);
const defaultReducerState$4 = getDefaultAsyncWrapperObj();
const workspaceServicePrincipalsGetPrefix = "WorkspaceServicePrincipalsGet";
const workspaceServicePrincipalsGetEpicReducerArg = {
  actionPrefix: workspaceServicePrincipalsGetPrefix,
  reduxKeyNested: (inputPayload) => [
    ROOT_REDUCER_KEYS.GLOBAL,
    GLOBAL_ACTION_KEYS.GET_SP
  ],
  loadResource: (request) => {
    return WPSResource.getWorkspaceServicePrincipals(request.workspaceId, request.identityType);
  },
  onCompleteSuccess: (resourcesResult) => resourcesResult
};
const workspaceServicePrincipalsGetEpicReducer = loadResourcesUtils(workspaceServicePrincipalsGetEpicReducerArg);
const defaultReducerState$3 = getDefaultAsyncWrapperObj();
const workspaceSecurityGroupsDeletePrefix = "WorkspaceSecurityGroupsDelete";
const workspaceSecurityGroupsDeleteEpicReducerArg = {
  actionPrefix: workspaceSecurityGroupsDeletePrefix,
  reduxKeyNested: (inputPayload) => [
    ROOT_REDUCER_KEYS.WORKSPACE_SG,
    WORKSPACE_SG_ACTION_KEYS.DELETE
  ],
  loadResource: (request) => {
    return WPSResource.deleteWorkspaceSecurityGroup(request.workspaceId, request.securityGroupId, request.experimentRole);
  },
  onCompleteSuccess: (resourcesResult) => resourcesResult
};
const workspaceSecurityGroupsDeleteEpicReducer = loadResourcesUtils(workspaceSecurityGroupsDeleteEpicReducerArg);
const defaultReducerState$2 = getDefaultAsyncWrapperObj();
const workspaceServicePrincipalsDeletePrefix = "WorkspaceServicePrincipalsDelete";
const workspaceServicePrincipalsDeleteEpicReducerArg = {
  actionPrefix: workspaceServicePrincipalsDeletePrefix,
  reduxKeyNested: (inputPayload) => [
    ROOT_REDUCER_KEYS.WORKSPACE_SP,
    WORKSPACE_SG_ACTION_KEYS.DELETE
  ],
  loadResource: (request) => {
    return WPSResource.deleteWorkspaceServicePrincipal(request.workspaceId, request.servicePrincipalId, request.identityType);
  },
  onCompleteSuccess: (resourcesResult) => resourcesResult
};
const workspaceServicePrincipalsDeleteEpicReducer = loadResourcesUtils(workspaceServicePrincipalsDeleteEpicReducerArg);
const defaultReducerState$1 = getDefaultAsyncWrapperObj();
const workspaceSecurityGroupsGetPrefix = "WorkspaceSecurityGroupsGet";
const workspaceSecurityGroupsGetEpicReducerArg = {
  actionPrefix: workspaceSecurityGroupsGetPrefix,
  reduxKeyNested: (inputPayload) => [ROOT_REDUCER_KEYS.GLOBAL, GLOBAL_ACTION_KEYS.GET_SG],
  loadResource: (request) => {
    return WPSResource.getSecurityGroups(request.workspaceId, request.keyValue);
  },
  onCompleteSuccess: (resourcesResult) => resourcesResult
};
const workspaceSecurityGroupsGetEpicReducer = loadResourcesUtils(workspaceSecurityGroupsGetEpicReducerArg);
const defaultReducerState = getDefaultAsyncWrapperObj();
const workspaceUAAAccessGetPrefix = "WorkspaceUAAAccessGet";
const workspaceUAAAccessGetEpicReducerArg = {
  actionPrefix: workspaceUAAAccessGetPrefix,
  reduxKeyNested: (inputPayload) => [
    ROOT_REDUCER_KEYS.GLOBAL,
    GLOBAL_ACTION_KEYS.GET_UAA_ACCESS
  ],
  loadResource: (request) => {
    return WPSResource.getUAAAccess(request.workspaceId);
  },
  onCompleteSuccess: (resourcesResult) => resourcesResult
};
const uaaAccessGetEpicReducer = loadResourcesUtils(workspaceUAAAccessGetEpicReducerArg);
var ROOT_REDUCER_KEYS = /* @__PURE__ */ ((ROOT_REDUCER_KEYS2) => {
  ROOT_REDUCER_KEYS2["METADATA"] = "metaData";
  ROOT_REDUCER_KEYS2["PROXY_STATUS"] = "proxyStatus";
  ROOT_REDUCER_KEYS2["WORKSPACE_SG"] = "workspaceSG";
  ROOT_REDUCER_KEYS2["WORKSPACE_SP"] = "workspaceSP";
  ROOT_REDUCER_KEYS2["GLOBAL"] = "global";
  return ROOT_REDUCER_KEYS2;
})(ROOT_REDUCER_KEYS || {});
var GLOBAL_ACTION_KEYS = /* @__PURE__ */ ((GLOBAL_ACTION_KEYS2) => {
  GLOBAL_ACTION_KEYS2["GET_SP"] = "getSP";
  GLOBAL_ACTION_KEYS2["GET_SG"] = "getSG";
  GLOBAL_ACTION_KEYS2["GET_UAA_ACCESS"] = "getUAAAccess";
  return GLOBAL_ACTION_KEYS2;
})(GLOBAL_ACTION_KEYS || {});
var METADATA_ACTION_KEYS = /* @__PURE__ */ ((METADATA_ACTION_KEYS2) => {
  METADATA_ACTION_KEYS2["GET"] = "get";
  return METADATA_ACTION_KEYS2;
})(METADATA_ACTION_KEYS || {});
var PROXY_STATUS_ACTION_KEYS = /* @__PURE__ */ ((PROXY_STATUS_ACTION_KEYS2) => {
  PROXY_STATUS_ACTION_KEYS2["GET"] = "get";
  PROXY_STATUS_ACTION_KEYS2["PUT"] = "put";
  return PROXY_STATUS_ACTION_KEYS2;
})(PROXY_STATUS_ACTION_KEYS || {});
var WORKSPACE_SG_ACTION_KEYS = /* @__PURE__ */ ((WORKSPACE_SG_ACTION_KEYS2) => {
  WORKSPACE_SG_ACTION_KEYS2["DELETE"] = "delete";
  WORKSPACE_SG_ACTION_KEYS2["PUT"] = "put";
  return WORKSPACE_SG_ACTION_KEYS2;
})(WORKSPACE_SG_ACTION_KEYS || {});
var WORKSPACE_SP_ACTION_KEYS = /* @__PURE__ */ ((WORKSPACE_SP_ACTION_KEYS2) => {
  WORKSPACE_SP_ACTION_KEYS2["DELETE"] = "delete";
  WORKSPACE_SP_ACTION_KEYS2["PUT"] = "put";
  return WORKSPACE_SP_ACTION_KEYS2;
})(WORKSPACE_SP_ACTION_KEYS || {});
const getWPSDefaultState = () => ({
  [
    "global"
    /* GLOBAL */
  ]: {
    [
      "getSG"
      /* GET_SG */
    ]: defaultReducerState$1,
    [
      "getSP"
      /* GET_SP */
    ]: defaultReducerState$4,
    [
      "getUAAAccess"
      /* GET_UAA_ACCESS */
    ]: defaultReducerState
  },
  [
    "metaData"
    /* METADATA */
  ]: {
    [
      "get"
      /* GET */
    ]: defaultReducerState$9
  },
  [
    "proxyStatus"
    /* PROXY_STATUS */
  ]: {
    [
      "get"
      /* GET */
    ]: defaultReducerState$7,
    [
      "put"
      /* PUT */
    ]: defaultReducerState$8
  },
  [
    "workspaceSG"
    /* WORKSPACE_SG */
  ]: {
    [
      "delete"
      /* DELETE */
    ]: defaultReducerState$3,
    [
      "put"
      /* PUT */
    ]: defaultReducerState$6
  },
  [
    "workspaceSP"
    /* WORKSPACE_SP */
  ]: {
    [
      "delete"
      /* DELETE */
    ]: defaultReducerState$2,
    [
      "put"
      /* PUT */
    ]: defaultReducerState$5
  }
});
const resetDeleteWorkspaceSGsName = "RESET_DELETE_WORKSPACE_SGS";
const resetDeleteWorkspaceSGs = createAction(resetDeleteWorkspaceSGsName, (action) => () => action());
const resetDeleteWorkspaceSPName = "RESET_DELETE_WORKSPACE_SP";
const resetDeleteWorkspaceSP = createAction(resetDeleteWorkspaceSPName, (action) => () => action());
const WPSReducer = (state = getWPSDefaultState(), actionResult) => {
  state = workspaceMetaDataLoadEpicReducer.reduxChange(state, actionResult);
  state = workspaceProxyStatusUpdateEpicReducer.reduxChange(state, actionResult);
  state = workspaceProxyStatusGetEpicReducer.reduxChange(state, actionResult);
  state = workspaceSecurityGroupsPutEpicReducer.reduxChange(state, actionResult);
  state = workspaceServicePrincipalsPutEpicReducer.reduxChange(state, actionResult);
  state = workspaceServicePrincipalsGetEpicReducer.reduxChange(state, actionResult);
  state = workspaceSecurityGroupsDeleteEpicReducer.reduxChange(state, actionResult);
  state = workspaceServicePrincipalsDeleteEpicReducer.reduxChange(state, actionResult);
  state = workspaceSecurityGroupsGetEpicReducer.reduxChange(state, actionResult);
  state = uaaAccessGetEpicReducer.reduxChange(state, actionResult);
  switch (actionResult.type) {
    case resetDeleteWorkspaceSGsName:
      return __spreadProps(__spreadValues({}, state), {
        workspaceSG: __spreadProps(__spreadValues({}, state.workspaceSG), {
          delete: defaultReducerState$3
        })
      });
    case resetDeleteWorkspaceSPName:
      return __spreadProps(__spreadValues({}, state), {
        workspaceSP: __spreadProps(__spreadValues({}, state.workspaceSP), {
          delete: defaultReducerState$2
        })
      });
  }
  return state;
};
export {
  GLOBAL_ACTION_KEYS as G,
  METADATA_ACTION_KEYS as M,
  PROXY_STATUS_ACTION_KEYS as P,
  ROOT_REDUCER_KEYS as R,
  WPSReducer as W,
  workspaceSecurityGroupsPutEpicReducer as a,
  workspaceSecurityGroupsGetEpicReducer as b,
  workspaceServicePrincipalsPutEpicReducer as c,
  workspaceSecurityGroupsDeleteEpicReducer as d,
  workspaceMetaDataLoadEpicReducer as e,
  workspaceProxyStatusGetEpicReducer as f,
  getWPSDefaultState as g,
  workspaceProxyStatusUpdateEpicReducer as h,
  workspaceServicePrincipalsDeleteEpicReducer as i,
  resetDeleteWorkspaceSGs as j,
  defaultReducerState$9 as k,
  defaultReducerState$8 as l,
  defaultReducerState$7 as m,
  defaultReducerState$6 as n,
  defaultReducerState$5 as o,
  defaultReducerState$4 as p,
  defaultReducerState$3 as q,
  resetDeleteWorkspaceSP as r,
  defaultReducerState$2 as s,
  defaultReducerState$1 as t,
  uaaAccessGetEpicReducer as u,
  defaultReducerState as v,
  workspaceServicePrincipalsGetEpicReducer as w,
  WORKSPACE_SG_ACTION_KEYS as x,
  WORKSPACE_SP_ACTION_KEYS as y
};
//# sourceMappingURL=workspaceSettingsReducer-0ce19298.js.map
